import { CardContent, Box } from '@mui/material';
import { ShoppingBag } from 'react-feather';
import { MinimalCard } from 'components/styled';

import { Typography, LinearProgress, StatsIcon } from './styles';

function Orders() {
  return (
    <Box position="relative">
      <MinimalCard $hoverEffect={false} sx={{ mb: 6, pt: 2 }}>
        <CardContent>
          <Typography variant="h2" gutterBottom>
            <Box fontWeight="fontWeightRegular">30</Box>
          </Typography>
          <Typography variant="body2" gutterBottom sx={{ mt: 3, mb: 0 }}>
            Orders Today
          </Typography>

          <StatsIcon>
            <ShoppingBag />
          </StatsIcon>
          <LinearProgress variant="determinate" value={30} color="secondary" sx={{ mt: 4 }} />
        </CardContent>
      </MinimalCard>
    </Box>
  );
}

export default Orders;
